module.exports = __webpack_public_path__ + "static/media/holiday_help_map_important.c86d467a.svg";